export default __webpack_public_path__ + "static/media/gl_arrow_down.12bdb03f.svg";